import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import YouTube from "react-youtube";

let allPlayers = []; // Global registry of players

const isValidYoutubeId = (id) => {
  return typeof id === "string" && /^[a-zA-Z0-9_-]{11}$/.test(id);
};

const YoutubePlayer = ({ videoId, height = "150", width = "300" }) => {
  const playerRef = useRef(null);

  const opts = {
    height,
    width,
    playerVars: {
      autoplay: 0,
    },
  };

  // Register player when ready
  const handleReady = (event) => {
    playerRef.current = event.target;
    allPlayers.push(event.target);
  };

  // Pause others when playing
  const handlePlay = () => {
    allPlayers.forEach((p) => {
      if (p !== playerRef.current) {
        p.pauseVideo();
      }
    });
  };

  useEffect(() => {
    return () => {
      // Remove from registry on unmount
      allPlayers = allPlayers.filter((p) => p !== playerRef.current);
    };
  }, []);

  if (!isValidYoutubeId(videoId)) {
    return (
      <div
        style={{
          color: "grey",
          backgroundColor: "#f0f0f0",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "1rem",
        }}
      >
        <p style={{ fontWeight: "bold", margin: 0, fontSize: "10px" }}>
          Invalid YouTube ID
        </p>
        <i
          className="bx bx-error"
          style={{
            fontSize: "2rem",
            marginTop: "0.5rem",
            color: "#ffcc00",
          }}
        />
      </div>
    );
  }

  return (
    <YouTube
      videoId={videoId}
      opts={opts}
      onReady={handleReady}
      onPlay={handlePlay}
    />
  );
};

YoutubePlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default YoutubePlayer;
